/* Capa de diseño · Tienda Luciano · v1 (mejora progresiva: si este archivo no carga, la tienda sigue funcionando igual)
   1) Colores de las tarjetas: el tema recibe el nombre del color en español («cafe», «dorado negro») y no sabe pintarlo,
      así que los puntitos salían vacíos. Acá se traducen los nombres a colores (bicolor = marco + lente).
   2) Cabecera: sombra al bajar y barra fina de avance de lectura, como en la landing.
   3) Aparición suave de las secciones al entrar en pantalla (respeta «reducir movimiento»). */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = false;
  try { reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- 1) colores ---------- */
  var BASE = {
    negro: '#1a1a1a', blanco: '#f4f1ea', hueso: '#efe6d2', crema: '#efe3c8', gris: '#8b8d90', plateado: '#b9bdc3', plata: '#b9bdc3',
    dorado: '#c9a44c', oro: '#c9a44c', cafe: '#6b4a2f', camel: '#b98a55', mostaza: '#c9a227', carey: '#8a5a2b', ambar: '#d08a2e',
    azul: '#3f6fb5', celeste: '#8fc1e3', turquesa: '#3fb0ac', verde: '#4f7a45', rojo: '#b3382e', burdeo: '#6e1f2e', vino: '#6e1f33',
    rosa: '#e6a4b4', rosado: '#e6a4b4', magenta: '#b5368a', morado: '#7a55a8', lavanda: '#b9a6d8', naranja: '#e08a2d', amarillo: '#e8c547',
    transparente: '#dcd6c9', neg: '#1a1a1a'
  };
  var FRASES = { 'ojo de tigre': ['#9a6a2a', '#3b2514', '#d8a24a'], 'piedra azul': ['#3a5a8c'] };
  var MODIF = { mate: 1, brillante: 1, oscuro: 1, claro: 1, degradado: 1, de: 1, y: 1 };

  function limpio(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z ]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function mezcla(hex, a, pct) {   // acerca el color a "a" (#000 o #fff) un pct %
    var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
    var m = parseInt(a.slice(1), 16), R = m >> 16, G = (m >> 8) & 255, B = m & 255;
    var f = function (x, y) { return Math.round(x + (y - x) * pct); };
    return '#' + ((1 << 24) + (f(r, R) << 16) + (f(g, G) << 8) + f(b, B)).toString(16).slice(1);
  }
  function colorDe(nombre) {
    var t = limpio(nombre), cols = [], k, grad = /degradado/.test(t), osc = /oscuro/.test(t), clar = /claro/.test(t);
    for (k in FRASES) if (t.indexOf(k) > -1) { cols = cols.concat(FRASES[k]); t = t.replace(k, ' '); }
    t.split(' ').forEach(function (p) { if (BASE[p]) cols.push(BASE[p]); else if (p && !MODIF[p]) { /* palabra desconocida: se ignora */ } });
    if (!cols.length) return '';
    if (osc) cols = cols.map(function (c) { return mezcla(c, '#000000', .35); });
    if (clar) cols = cols.map(function (c) { return mezcla(c, '#ffffff', .4); });
    if (cols.length === 1) {
      if (grad) return 'linear-gradient(135deg,' + cols[0] + ',' + mezcla(cols[0], '#ffffff', .6) + ')';
      if (t === 'carey') return 'radial-gradient(circle at 30% 30%,#c48a3f,#8a5a2b 55%,#3b2514)';
      return cols[0];
    }
    var paso = 100 / cols.length, stops = cols.map(function (c, i) { return c + ' ' + (i * paso).toFixed(1) + '% ' + ((i + 1) * paso).toFixed(1) + '%'; });
    return 'linear-gradient(135deg,' + (grad ? cols.join(',') : stops.join(',')) + ')';
  }
  function pintarColores(raiz) {
    (raiz || d).querySelectorAll('.color-swatch:not([data-lu])').forEach(function (l) {
      l.setAttribute('data-lu', '1');
      var actual = (l.style.getPropertyValue('--swatch-color') || '').trim();
      if (/^(url\(|#|rgb|hsl|linear-gradient|radial-gradient)/i.test(actual)) return;   // ya trae imagen o color válido (ficha de producto)
      var g = colorDe(l.getAttribute('title') || l.textContent);
      if (g) l.style.setProperty('--swatch-color', g);
    });
  }

  /* ---------- 2) cabecera ---------- */
  function cabecera() {
    var h = d.querySelector('.header-wrapper');
    if (!h) return;
    var barra = d.createElement('i'); barra.className = 'lu-progreso'; barra.setAttribute('aria-hidden', 'true');
    h.appendChild(barra);
    var tick = false;
    function pinta() {
      tick = false;
      var y = w.pageYOffset || d.documentElement.scrollTop, max = Math.max(1, d.documentElement.scrollHeight - w.innerHeight);
      h.classList.toggle('lu-scroll', y > 8);
      barra.style.transform = 'scaleX(' + Math.min(1, y / max).toFixed(4) + ')';
    }
    w.addEventListener('scroll', function () { if (!tick) { tick = true; w.requestAnimationFrame(pinta); } }, { passive: true });
    pinta();
  }

  /* ---------- 3) aparición suave ---------- */
  function aparecer() {
    if (reduce || !('IntersectionObserver' in w)) return;
    var sel = '.shopify-section:not(.section-announcement):not(.shopify-section-header) .product-card, .collection-card, .highlights__item, .article-card, .lookbook__item, .lu-head, .lu-pasos__item, .lu-plazos, .lu-perk, .lu-vis__card, .lu-faq__lado, .lu-q, .lu-cta__in, .heading-group, .spotlight-cards__item, .featured-products__info, .media-banner__content, .collections-list__item, .text-banner__content, .image-with-text__content, .multicolumn-card, .highlights__content';
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lu-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    function marcar(raiz) {
      (raiz || d).querySelectorAll(sel).forEach(function (el) {
        if (el.hasAttribute('data-lu-r')) return;
        el.setAttribute('data-lu-r', '1');
        if (el.closest('.swiper, swiper-container, [class*=slider]')) return;   // los carruseles ya traen su propio movimiento
        var r = el.getBoundingClientRect();
        if (r.top < w.innerHeight * 0.95 && r.bottom > 0) return;   // ya visible: no se anima (evita parpadeo)
        var pa = el.parentElement; pa.__luN = (pa.__luN || 0) + 1;
        el.style.setProperty('--i', String((pa.__luN - 1) % 6));
        el.classList.add('lu-pre'); io.observe(el);
      });
    }
    marcar();
    return marcar;
  }

  /* ---------- 4) garantías visibles: ficha de producto y bajo el hero ----------
     Solo lo que las políticas de la tienda confirman (envío: /policies/shipping-policy; devoluciones: /policies/refund-policy).
     «3 cuotas sin interés» y «envío gratis sobre $50.000» aparecen en la franja de la tienda pero NO en sus políticas:
     quedan apagadas (cuotas / envioGratis) hasta que el cliente las confirme. Para activarlas, definir window.LUCIANO_CONFIG antes de este archivo. */
  var CFG = w.LUCIANO_CONFIG || {};
  function listaGarantias() {                                       // [texto largo, texto corto]
    var l = [];
    if (CFG.envioGratis) l.push([CFG.envioGratis, CFG.envioGratis]);   // p. ej. 'Envío gratis sobre $50.000'
    if (CFG.cuotas) l.push([CFG.cuotas, CFG.cuotas]);                  // p. ej. '3 cuotas sin interés'
    l.push(['Retiro gratis en Ñuñoa en 24 a 48 horas hábiles', 'Retiro gratis en Ñuñoa']);
    l.push(['Despacho a todo Chile con BlueExpress', 'Despacho a todo Chile']);
    l.push(['10 días para cambios y devoluciones', '10 días para cambios']);
    return l.slice(0, 4);
  }
  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.2"/><path d="M8 12.4l2.7 2.7L16 9.6"/></svg>';
  function garantias() {
    var bb = d.querySelector('.product__info-container .product__buy-buttons');
    if (!bb || d.querySelector('.lu-garantias')) return;
    var ul = d.createElement('ul'); ul.className = 'lu-garantias';
    listaGarantias().forEach(function (t) { var li = d.createElement('li'); li.innerHTML = CHECK + '<span></span>'; li.lastChild.textContent = t[0]; ul.appendChild(li); });
    bb.insertAdjacentElement('afterend', ul);
  }
  function pruebaHero() {
    var hero = d.querySelector('.hero-section');
    if (!hero || d.querySelector('.lu-prueba, .lu-ticker')) return;
    var cont = d.createElement('div'); cont.className = 'lu-prueba'; cont.setAttribute('role', 'list'); cont.setAttribute('tabindex', '0'); cont.setAttribute('aria-label', 'Garantías de compra');
    listaGarantias().slice(0, 3).forEach(function (t) { var it = d.createElement('div'); it.className = 'lu-prueba__it'; it.setAttribute('role', 'listitem'); it.innerHTML = CHECK + '<span></span>'; it.lastChild.textContent = t[1]; cont.appendChild(it); });
    hero.insertAdjacentElement('afterend', cont);
  }
  /* ---------- WhatsApp (apagado hasta que el cliente confirme el número: window.LUCIANO_CONFIG = { whatsapp: '56912345678' }) ---------- */
  function whatsapp() {
    var num = String(CFG.whatsapp || '').replace(/\D/g, '');
    if (num.length < 9 || d.querySelector('.lu-wa, .lu-wa-li')) return;
    var h1 = d.querySelector('.product__title'), esFicha = !!h1;
    var msg = esFicha ? 'Hola, quiero consultar por este producto: ' + h1.textContent.trim() + ' ' + location.href.split('?')[0] : 'Hola, tengo una consulta sobre la tienda.';
    var url = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
    var ico = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="currentColor"><path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.9L2 22l5.25-1.5A9.9 9.9 0 1 0 12.04 2zm0 1.8a8.1 8.1 0 1 1-4.15 15.07l-.3-.18-3.1.89.9-3.02-.2-.31A8.1 8.1 0 0 1 12.04 3.8zm-3.1 4.2c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.07 3.3 5.1 4.5 2.5 1 3.03.8 3.57.75.55-.05 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.08-.12-.28-.2-.58-.35-.3-.15-1.77-.87-2.05-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.17-.3-.02-.47.13-.62.14-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5z"/></svg>';
    var lista = esFicha && d.querySelector('.lu-garantias');
    if (lista) {   // en la ficha va como una línea más junto al botón de compra (un botón flotante taparía el carro)
      var li = d.createElement('li'); li.className = 'lu-wa-li';
      var b = d.createElement('a'); b.href = url; b.target = '_blank'; b.rel = 'noopener'; b.innerHTML = ico + '<span>¿Dudas? Consúltanos por WhatsApp</span>';
      li.appendChild(b); lista.appendChild(li); return;
    }
    var a = d.createElement('a');
    a.className = 'lu-wa'; a.href = url; a.target = '_blank'; a.rel = 'noopener'; a.setAttribute('aria-label', 'Consultar por WhatsApp');
    a.innerHTML = ico.replace('width="22" height="22"', 'width="26" height="26"') + '<span class="lu-wa__txt">WhatsApp</span>';
    d.body.appendChild(a);
  }

  /* acordeón «Envíos y devoluciones» bajo la descripción (datos de /policies/shipping-policy y /policies/refund-policy, vigentes al 3-abr-2026) */
  function acordeonEnvios() {
    var acc = d.querySelector('.product-accordion');
    if (!acc || d.querySelector('.lu-acordeon')) return;
    var icono = acc.querySelector('.product-accordion__icon');
    var wrap = d.createElement('div'); wrap.className = 'product-accordion lu-acordeon';
    wrap.innerHTML =
      '<button class="button button--simple product-accordion__toggle focus-inset" aria-expanded="false" aria-label="Envíos y devoluciones"><div class="button__content"><span class="button__label">Envíos y devoluciones</span><div class="product-accordion__icon">' + (icono ? icono.innerHTML : '') + '</div></div></button>' +
      '<div class="product-accordion__content"><div class="rte rte--product">' +
      '<p><strong>Retiro en tienda:</strong> gratis, listo en 24 a 48 horas hábiles (Bazar Equilibrarte, Av. Italia 1418, Ñuñoa).</p>' +
      '<p><strong>Despacho:</strong> a todo Chile con BlueExpress. El costo se calcula al pagar, según la comuna de destino y el peso del pedido.</p>' +
      '<p><strong>Plazos estimados:</strong> Región Metropolitana 2 a 4 días hábiles; regiones (zonas urbanas) 3 a 7; zonas extremas y rurales 5 a 12.</p>' +
      '<p><strong>Cambios y devoluciones:</strong> 10 días corridos desde que recibes el producto, sin uso y en su empaque original.</p>' +
      '<p><a href="/policies/shipping-policy">Política de envío</a> · <a href="/policies/refund-policy">Política de devoluciones</a></p>' +
      '</div></div>';
    acc.insertAdjacentElement('afterend', wrap);
    var b = wrap.querySelector('button'), c = wrap.querySelector('.product-accordion__content');
    b.addEventListener('click', function () {
      var abre = !b.classList.contains('active');
      b.classList.toggle('active', abre); c.classList.toggle('active', abre); b.setAttribute('aria-expanded', abre ? 'true' : 'false');
    });
  }
  /* título del hero: la última frase en cursiva (como «elegidos con intención» en la landing) */
  function tituloHero() {
    var h = d.querySelector('.hero__heading');
    if (!h || h.getAttribute('data-lu')) return;
    h.setAttribute('data-lu', '1');
    var txt = (h.textContent || '').trim(), m = txt.match(/^(.+?[.!?])\s+(.+)$/);
    if (!m || h.children.length > 0) return;
    h.textContent = ''; h.appendChild(d.createTextNode(m[1] + ' '));
    var em = d.createElement('em'); em.textContent = m[2]; h.appendChild(em);
  }

  /* ---------- títulos de sección: sin mayúsculas sostenidas y con la última palabra en cursiva (el sistema de la landing) ---------- */
  function acentosTitulos() {
    d.querySelectorAll('.popular-products .heading-group .title, .spotlight-cards .heading-group .title, .highlights .heading-group .title, .blog-posts .heading-group .title, .image-with-text .heading-group .title, .lookbook .heading-group .title, .collections-list .heading-group .title').forEach(function (el) {
      if (el.hasAttribute('data-lu-acento') || el.querySelector('em')) return;
      el.setAttribute('data-lu-acento', '1');
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim(); if (!t) return;
      if (t === t.toUpperCase() && /[A-ZÁÉÍÓÚÑ]{2}/.test(t)) t = t.charAt(0) + t.slice(1).toLowerCase();
      var p = t.split(' ');
      el.textContent = '';
      if (p.length < 2) { el.appendChild(d.createTextNode(t)); return; }
      el.appendChild(d.createTextNode(p.slice(0, -1).join(' ') + ' '));
      var em = d.createElement('em'); em.className = 'lu-acento'; em.textContent = p[p.length - 1]; el.appendChild(em);
    });
  }

  /* ---------- rendimiento: el hero tiene 6 láminas; solo la primera carga de inmediato (ver preparar_tema.py, paso K). Las demás se piden al terminar la carga ---------- */
  function precargarHero() {
    var ir = function () { d.querySelectorAll('.hero__image[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); };
    if (d.readyState === 'complete') w.setTimeout(ir, 1200); else w.addEventListener('load', function () { w.setTimeout(ir, 1200); });
  }

  /* ---------- 5) precios: «$20,000» -> «$20.000» (formato chileno). Si en Shopify se corrige el formato de moneda, esto deja de actuar ---------- */
  var RE_PRECIO = /\$(\d{1,3}(?:,\d{3})+)(?!\d)/g;
  function precios(raiz) {
    var base = raiz && raiz.nodeType === 1 ? raiz : d.body;
    var it = d.createTreeWalker(base, NodeFilter.SHOW_TEXT, null), n, lote = [];
    while ((n = it.nextNode())) {
      if (n.nodeValue.indexOf('$') > -1 && RE_PRECIO.test(n.nodeValue)) lote.push(n);
      RE_PRECIO.lastIndex = 0;
    }
    lote.forEach(function (t) {
      var p = t.parentNode; if (!p || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(p.nodeName)) return;
      t.nodeValue = t.nodeValue.replace(RE_PRECIO, function (m, g) { return '$' + g.replace(/,/g, '.'); });
    });
  }

  /* ---------- categorías: el fondo de cada foto toma el color de sus bordes ----------
     Las fotos de «Lentes», «Accesorios» y «Camisas» tienen proporciones distintas; se muestran enteras y el espacio sobrante queda
     del mismo color que la propia foto (se mide en una copia pequeña; si el navegador no deja leer los píxeles, queda el gris neutro del CSS). */
  function fondosCategorias() {
    d.querySelectorAll('.spotlight-cards__image-wrapper').forEach(function (wr) {
      if (wr.hasAttribute('data-lu-fondo')) return;
      var img = wr.querySelector('img'); var src = img && (img.currentSrc || img.src); if (!src) return;
      wr.setAttribute('data-lu-fondo', '1');
      var t = new w.Image(); t.crossOrigin = 'anonymous';
      t.onload = function () {
        try {
          var N = 40, c = d.createElement('canvas'); c.width = N; c.height = N;
          var x = c.getContext('2d'); x.drawImage(t, 0, 0, N, N);
          var px = x.getImageData(0, 0, N, N).data, r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < N; i++) for (var k = 0; k < N; k++) {
            if (i > 1 && i < N - 2 && k > 1 && k < N - 2) continue;       /* solo el anillo exterior */
            var o = (i * N + k) * 4; if (px[o + 3] < 40) continue;          /* sin los píxeles transparentes */
            r += px[o]; g += px[o + 1]; b += px[o + 2]; n++;
          }
          if (n > 20) wr.style.backgroundColor = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
        } catch (e) {}
      };
      t.src = src;
    });
  }

  /* ---------- enlaces a colecciones que no existen (hoy: Ofertas, Gorros, Billeteras y Bufandas dan 404 desde el menú, el pie y el inicio) ----------
     Se ocultan solos mientras la colección no exista y reaparecen cuando se cree. La lista sale de /collections.json (solo colecciones publicadas). */
  function enlacesRotos() {
    /* filas de «Colecciones» sin enlace (la colección ya no existe: el tema deja solo el título y una foto vacía); no necesita red */
    d.querySelectorAll('.collections-list__item').forEach(function (f) {
      if (!f.querySelector('a[href]') && !f.hasAttribute('data-lu-roto')) { f.setAttribute('data-lu-roto', '1'); f.hidden = true; f.style.display = 'none'; }
    });
    var KEY = 'luCols2', ahora = Date.now(), cache = null;
    try { var c = JSON.parse(w.sessionStorage.getItem(KEY) || 'null'); if (c && ahora - c.t < 3600000) cache = c.h; } catch (e) {}
    function manijas() {   /* handles de colecciones enlazadas en la página */
      var s = {};
      d.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
        if (a.hostname !== w.location.hostname) return;
        var m = a.pathname.replace(/\/+$/, '').match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)$/i); if (m) s[decodeURIComponent(m[1]).toLowerCase()] = 1;
      });
      return Object.keys(s);
    }
    function aplicar(ok) {   /* ok: handles que existen Y tienen productos a la vista */
      d.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
        if (a.hostname !== w.location.hostname) return;
        var m = a.pathname.replace(/\/+$/, '').match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^/]+)$/i); if (!m) return;   /* solo enlaces a la colección misma, nunca a un producto dentro de ella */
        var h = decodeURIComponent(m[1]).toLowerCase(); if (h === 'all' || h === 'frontpage' || ok.indexOf(h) >= 0) return;
        var cont = a.closest('li') || a.closest('.collections-list__item, .spotlight-cards__item');
        if (cont && !cont.hasAttribute('data-lu-roto')) { cont.setAttribute('data-lu-roto', '1'); cont.hidden = true; cont.style.display = 'none'; }
      });
    }
    if (cache) return aplicar(cache);
    if (!w.fetch) return;
    var lista = manijas(); if (!lista.length) return;
    w.fetch('/collections.json?limit=250', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.collections || !j.collections.length) return;
      var existen = j.collections.map(function (c) { return c.handle; });
      /* una colección que existe pero no muestra ningún producto (por ejemplo, con productos aún sin publicar) tampoco se enlaza */
      return Promise.all(existen.filter(function (h) { return lista.indexOf(h) >= 0; }).map(function (h) {
        return w.fetch('/collections/' + h + '/products.json?limit=1', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return (p && p.products && p.products.length === 0) ? null : h; }).catch(function () { return h; });
      })).then(function (oks) {
        var ok = oks.filter(Boolean).concat(existen.filter(function (h) { return lista.indexOf(h) < 0; }));
        try { w.sessionStorage.setItem(KEY, JSON.stringify({ t: ahora, h: ok })); } catch (e) {}
        aplicar(ok);
      });
    }).catch(function () {});
  }

  /* ---------- 6) textos del tema mal traducidos o en inglés (se corrigen mejor en locales/es.json; esto es la red de seguridad) ---------- */
  var TEXTOS = { 'Cerca': 'Cerrar', 'Verificar': 'Finalizar compra' };
  function textos(raiz) {
    (raiz || d).querySelectorAll('.button__label, .modal-close-button, .cart-drawer__header-title .subtitle, [aria-label="Cerca"]').forEach(function (e) {
      if (e.getAttribute && e.getAttribute('aria-label') === 'Cerca') e.setAttribute('aria-label', 'Cerrar');
      if (e.children.length === 0) {
        var t = (e.textContent || '').trim();
        if (TEXTOS[t]) e.textContent = TEXTOS[t];
        else if (/^Su carrito\b/.test(t)) e.textContent = t.replace(/^Su carrito/, 'Tu carro');
      }
    });
  }

  /* cada mejora corre aislada: si una falla, las demás siguen y la tienda no se ve afectada */
  function seguro(fn) { try { return fn(); } catch (e) { if (w.console && console.warn) console.warn('[luciano-diseno]', e && e.message); } }
  function iniciar() {
    seguro(pintarColores); seguro(precios); seguro(textos); seguro(enlacesRotos); seguro(fondosCategorias); seguro(acentosTitulos); seguro(precargarHero); seguro(tituloHero); seguro(pruebaHero);
    seguro(garantias); seguro(acordeonEnvios); seguro(whatsapp); seguro(cabecera);
    var marcar = seguro(aparecer);
    var t = 0;
    new MutationObserver(function () {   // "ver más", vista rápida, carruseles: contenido que llega después
      clearTimeout(t);
      t = setTimeout(function () {
        seguro(pintarColores); seguro(precios); seguro(textos); seguro(enlacesRotos); seguro(garantias); seguro(acordeonEnvios);
        if (marcar) seguro(function () { marcar(); });
      }, 120);
    }).observe(d.body, { childList: true, subtree: true });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
